import { useState, useEffect } from "react"
import { useApp } from "../../context/useApp"
import {
  documentTypes,
  provinces,
  actualPropertyTypes,
  requestTypes,
  vehicleTypes,
} from "../../actions/global-actions-data"
import {
  finantialInformationType,
  propertyTypes,
} from "../properties/create-property-data"
import {
  createRequest,
  getPropertyByCode,
} from "../../actions/property-actions"
import { useParams } from "react-router-dom"
import DateInput from "../../components/DateInput"
import { requestRequirements } from "./request-data"
import logo from "../../assets/logo-inmobiliaria.jpeg"
import { alert } from "../../components/Alert"
import { stringToCurrency } from "../../components/StringToCurrency"
import { CreateField } from "../../components/CreateField"
import {
  BsPersonFill,
  BsHouseFill,
  BsBriefcaseFill,
  BsBuilding,
  BsCarFront,
  BsCurrencyDollar,
  BsPhone,
  BsFileEarmarkText,
  BsCheckCircle,
  BsChevronRight,
  BsChevronLeft,
  BsExclamationTriangle,
} from "react-icons/bs"
import "./request.css"

function Request() {
  const { setLoading } = useApp()
  const params = useParams()

  // Estado para formulario multi-paso
  const [currentStep, setCurrentStep] = useState(0)
  const totalSteps = 7

  // Funciones utilitarias para manejar valores anidados
  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc?.[part], obj) ?? ""
  }

  const setNestedValue = (obj, path, value) => {
    const parts = path.split(".")
    let current = obj
    for (let i = 0; i < parts.length - 1; i++) {
      if (!current[parts[i]]) current[parts[i]] = {}
      current = current[parts[i]]
    }
    current[parts[parts.length - 1]] = value
  }

  // Templates de objetos
  const cosignerObj = {
    firstName: "",
    lastName: "",
    documentType: "",
    document: "",
    email: "",
    phone: "",
    cosignerProvince: "",
    cosignerCity: "",
    address: "",
  }

  const propertyObj = {
    type: "",
    address: "",
    propertyProvince: "",
    propertyCity: "",
    value: "",
    realEstateRegistration: "",
  }

  const vehicleObj = {
    type: "",
    brand: "",
    model: "",
    plaque: "",
  }

  const finantialObj = {
    type: "",
    entity: "",
    value: "",
    fee: "",
    remaining: "",
  }

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    documentType: "",
    document: "",
    email: "",
    phone: "",
    occupation: "",
    dependents: "",
    peopleWhoWillLive: "",
    monthlyExpenses: "",
    monthlyIncome: "",
    actualProperty: {
      type: "",
      address: "",
      neighborhood: "",
      actualPropertyProvince: "",
      actualPropertyCity: "",
      landlord: "",
      landlordPhone: "",
      monthlyCost: "",
      administrationCost: "",
      antiquity: "",
    },
    userType: "Empleado",
    employee: {
      company: "",
      address: "",
      position: "",
      salary: "",
      admissionDay: "",
    },
    independent: {
      activity: "",
      address: "",
      employeesNumber: "",
      income: "",
      expenses: "",
    },
    pensionary: {
      reason: "",
      value: "",
    },
    properties: [{ ...propertyObj }],
    vehicles: [{ ...vehicleObj }],
    finantialInformation: [{ ...finantialObj }],
    references: [
      {
        type: "Familiar",
        fullname: "",
        phone: "",
        relationship: "",
      },
      {
        type: "Personal",
        fullname: "",
        phone: "",
        relationship: "",
      },
      {
        type: "Comercial",
        fullname: "",
        phone: "",
        relationship: "",
      },
      {
        type: "Comercial",
        fullname: "",
        phone: "",
        relationship: "",
      },
    ],
    cosigners: [],
    description: "",
    acceptTerms: false,
  })

  const [citiesData, setCitiesData] = useState({
    cities: [],
    actualPropertyCities: [],
    propertiesCities: [],
    cosignersCities: [],
  })

  const [loadData, setLoadData] = useState(true)
  const [currentData, setCurrentData] = useState({})
  const [requirements, setRequirements] = useState([])
  const descriptionText =
    "DECLARO QUE LA INFORMACIÓN SUMINISTRADA EN EL PRESENTE FORMATO ES VERÍDICA Y ASUMO MI RESPONSABILIDAD PLENA POR LA INFORMACIÓN REPORTADA. TODAS MIS ACTIVIDADES LAS ADELANTO DENTRO DEL MARCO DE LA LEGALIDAD Y MANIFIESTO QUE LOS RECURSOS QUE ME PERTENECEN TIENEN SU ORIGEN EN LAS SIGUIENTES FUENTES (DETALLAR OFICIO, OCUPACIÓN, ACTIVIDAD, NEGOCIO, ETC.): ".toLocaleLowerCase()
  const acceptText =
    "Autorizo al propietario o administrador para la recolección, almacenamiento, tratamiento y uso de mis datos personales con la finalidad de vincularme como cliente o usuario de A&H GROUP SAS y sus empresas o personas vinculadas."

  const [isSubmitted, setIsSubmitted] = useState(false)
  const [missingFields, setMissingFields] = useState([])

  useEffect(() => {
    if (loadData) {
      ;(async () => {
        try {
          const data = await getPropertyByCode(params.code, setLoading)
          if (data.code === "01") {
            alert("Error", data.message)
            return
          }
          // console.log("propiedad", data.data[0])
          let currentProperty = data.data[0]
          if (!currentProperty) {
            alert(
              "Error",
              "No se encontró ningún inmueble con el código ingresado",
            )
            return
          }

          currentProperty.ubication = `${currentProperty.address} B/${currentProperty.neighborhood} ${currentProperty.city}, ${currentProperty.province}`

          if (currentProperty.monthCost > 1000000) {
            form.cosigners.push({ ...cosignerObj })
            form.cosigners.push({ ...cosignerObj })
          } else {
            form.cosigners.push({ ...cosignerObj })
          }

          setRequirements([...requestRequirements.employee])

          setCurrentData(currentProperty)

          setForm({
            ...form,
          })
        } catch (error) {
          console.error("Error loading property:", error)
        }
      })()

      setLoadData(false)

      setForm({
        propertyID: "",
        firstName: "",
        lastName: "",
        documentType: "",
        document: "",
        email: "",
        phone: "",
        occupation: "",
        dependents: "",
        peopleWhoWillLive: "",
        monthlyExpenses: "",
        monthlyIncome: "",
        actualProperty: {
          type: "",
          address: "",
          neighborhood: "",
          actualPropertyProvince: "",
          actualPropertyCity: "",
          landlord: "",
          landlordPhone: "",
          monthlyCost: "",
          administrationCost: "",
          antiquity: "",
        },
        userType: "Empleado",
        employee: {
          company: "",
          address: "",
          position: "",
          salary: "",
          admissionDay: "",
        },
        independent: {
          activity: "",
          address: "",
          employeesNumber: "",
          income: "",
          expenses: "",
        },
        pensionary: {
          reason: "",
          value: "",
        },
        properties: [{ ...propertyObj }],
        vehicles: [{ ...vehicleObj }],
        finantialInformation: [{ ...finantialObj }],
        references: [
          {
            type: "Familiar",
            fullname: "",
            phone: "",
            relationship: "",
          },
          {
            type: "Personal",
            fullname: "",
            phone: "",
            relationship: "",
          },
          {
            type: "Comercial",
            fullname: "",
            phone: "",
            relationship: "",
          },
          {
            type: "Comercial",
            fullname: "",
            phone: "",
            relationship: "",
          },
        ],
        cosigners: [],
        description: "",
        acceptTerms: false,
      })
    }
  }, [loadData, form, params.code])

  const handleInputChange = (name, value) => {
    // Manejar tanto event como (name, value)
    if (name && typeof name === "object" && name.target) {
      const event = name
      name = event.target.name
      value = event.target.value
    }

    if (!name || typeof name !== "string") {
      return
    }

    if (name === "userType") {
      switch (value) {
        case "Empleado":
          setRequirements([...requestRequirements.employee])
          break
        case "Independiente":
          setRequirements([...requestRequirements.independent])
          break
        case "Pensionado":
          setRequirements([...requestRequirements.pensionary])
          break
        case "Persona Jurídica":
          setRequirements([...requestRequirements.juridical])
          break
        default:
          setRequirements([...requestRequirements.employee])
          break
      }
    }

    // Manejar campos anidados
    if (name.includes(".")) {
      const newForm = JSON.parse(JSON.stringify(form))
      setNestedValue(newForm, name, value)
      setForm(newForm)
    } else {
      setForm({
        ...form,
        [name]: value,
      })
    }
  }

  const handleOnChange = (event) => {
    const value = event.target.value
    const name = event.target.name

    if (value !== "" && value) {
      const cities = provinces.find((x) => x.name === value).cities
      //console.log('name', name);
      switch (name) {
        case "actualPropertyProvince":
          setCitiesData({
            ...citiesData,
            actualPropertyCities: cities,
          })
          setForm({
            ...form,
            actualProperty: {
              ...form.actualProperty,
              [name]: value,
            },
          })
          break
        default:
          console.log("sin caso")
          break
      }
      return
    }

    switch (name) {
      case "actualPropertyProvince":
        setCitiesData({
          ...citiesData,
          actualPropertyCities: [],
        })
        setForm({
          ...form,
          actualProperty: {
            ...form.actualProperty,
            actualPropertyProvince: "",
            actualPropertyCity: "",
          },
        })
        break
      default:
        console.log("sin caso")
        break
    }
  }

  const handleInsideInputChange = (field, event) => {
    const { name, value } = event.target
    const newForm = JSON.parse(JSON.stringify(form))
    setNestedValue(newForm, `${field}.${name}`, value)
    setForm(newForm)
  }

  const handleDynamicInputChange = (field, index, event) => {
    let newArray = [...form[field]]
    newArray[index][event.target.name] = event.target.value

    setForm({
      ...form,
      [field]: [...newArray],
    })
  }

  const handleDynamicOnChange = (field, citiesName, index, event) => {
    const value = event.target.value
    const name = event.target.name

    if (value !== "" && value) {
      const cities = provinces.find((x) => x.name === value).cities
      let newCitiesArray = [...citiesData[citiesName]]
      newCitiesArray[index] = cities

      setCitiesData({
        ...citiesData,
        [citiesName]: [...newCitiesArray],
      })

      let newArray = [...form[field]]
      newArray[index][name] = value

      setForm({
        ...form,
        [field]: [...newArray],
      })
      return
    }

    let newCitiesArray = [...citiesData[citiesName]]

    newCitiesArray[index] = []
    setCitiesData({
      ...citiesData,
      [citiesName]: [...newCitiesArray],
    })

    let newArray = [...form[field]]
    if (field === "properties") {
      newArray[index]["propertyProvince"] = ""
      newArray[index]["propertyCity"] = ""
    } else {
      newArray[index]["cosignerProvince"] = ""
      newArray[index]["cosignerCity"] = ""
    }

    setForm({
      ...form,
      [field]: [...newArray],
    })
  }

  const handleDateChange = (name, date) => {
    setForm({
      ...form,
      employee: {
        ...form.employee,
        [name]: date,
      },
    })
  }

  const addObj = (option) => {
    let newArray = [...form[option]]
    switch (option) {
      case "properties":
        newArray.push({ ...propertyObj })
        break
      case "vehicles":
        newArray.push({ ...vehicleObj })
        break
      case "cosigners":
        newArray.push({ ...cosignerObj })
        break
      case "finantialInformation":
        newArray.push({ ...finantialObj })
        break
      default:
        console.log("default")
        break
    }
    setForm({
      ...form,
      [option]: [...newArray],
    })
  }

  let deleteObj = (option, i) => {
    if (form[option].length > 1) {
      let newFormValues = { ...form }
      newFormValues[option].splice(i, 1)
      setForm({ ...newFormValues })
    }
  }

  let deleteCosigner = (i) => {
    if (currentData.monthCost > 1000000) {
      if (form.cosigners.length > 2) {
        let newFormValues = { ...form }
        newFormValues.cosigners.splice(i, 1)
        setForm({ ...newFormValues })
      }
    } else {
      if (form.cosigners.length > 1) {
        let newFormValues = { ...form }
        newFormValues.cosigners.splice(i, 1)
        setForm({ ...newFormValues })
      }
    }
  }

  const handleCheckChange = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.checked,
    })
  }

  const checkEmptyfield = (value) => {
    if (!isSubmitted) return ""

    // Validar booleanos
    if (typeof form[value] === "boolean" && form[value] === false) {
      return "empty"
    }

    // Validar campos vacíos/null
    if (form[value] === "" || form[value] === null) {
      return "empty"
    }

    // Validar email
    if (
      value === "email" &&
      form[value] &&
      !form[value].match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
    ) {
      return "empty"
    }

    return ""
  }

  const checkInsideEmptyfield = (field, value) => {
    if (
      isSubmitted &&
      (form[field][value] === "" || form[field][value] === null)
    ) {
      return "empty"
    }
    return ""
  }

  const checkDynamicEmptyField = (field, index, value) => {
    if (
      isSubmitted &&
      (form[field][index][value] === "" || form[field][index][value] === null)
    ) {
      return "empty"
    }
    return ""
  }

  const handleOnSubmit = (event) => {
    event.preventDefault()
    setIsSubmitted(true)

    const missingFieldsList = getMissingFields()
    const hasErrors = Object.values(missingFieldsList).some(
      (fields) => fields.length > 0,
    )

    if (hasErrors) {
      setMissingFields(missingFieldsList)

      let alertMessage = "Los siguientes campos deben ser completados:\n"
      for (const [section, fields] of Object.entries(missingFieldsList)) {
        if (fields.length > 0) {
          alertMessage += `\n${section}:\n`
          for (let i = 0; i < fields.length; i++) {
            alertMessage += `  • ${fields[i]}\n`
          }
        }
      }

      alert("¡Campos Incompletos!", alertMessage)
      return
    }

    if (form.acceptTerms === false) {
      alert("¡Atención!", "Debe aceptar la política de tratamiento de datos")
      return
    }

    setIsSubmitted(false)
    let data = JSON.parse(JSON.stringify(currentData))

    data.requests.push(form)
    //console.log('data', data.requests);

    createRequest(data, createFunction)
  }

  const handleNextStep = () => {
    // Solo resetear si aún no ha intentado enviar
    // Si ya intentó enviar, mantener el estado de errores en otros pasos
    if (!isSubmitted) {
      setMissingFields({})
    }
    // Avanzar al siguiente paso
    setTimeout(() => {
      setCurrentStep(Math.min(totalSteps - 1, currentStep + 1))
    }, 100)
  }

  const validateFields = () => {
    for (const field in form) {
      if (form.hasOwnProperty(field)) {
        // Objetos
        switch (form.userType) {
          case "Empleado":
            if (
              typeof form[field] === "object" &&
              field !== "vehicles" &&
              field !== "properties" &&
              field !== "finantialInformation" &&
              field !== "independent" &&
              field !== "pensionary" &&
              form[field] !== null
            ) {
              for (const fieldInside in form[field]) {
                if (form[field].hasOwnProperty(fieldInside)) {
                  //console.log(`Empleado ${fieldInside}x2: ${form[field][fieldInside]}`);
                  //console.log(`type: ${form.userType}`);

                  if (
                    typeof form[field][fieldInside] === "object" &&
                    form[field][fieldInside] !== null
                  ) {
                    for (const fieldArray in form[field][fieldInside]) {
                      if (form[field][fieldInside].hasOwnProperty(fieldArray)) {
                        console.log(
                          `Empleado ${fieldArray}x3: ${form[field][fieldInside][fieldArray]}`,
                        )
                        console.log(`type: ${form[field][fieldInside]["type"]}`)

                        if (
                          fieldArray === "relationship" &&
                          form[field][fieldInside][fieldArray] === "" &&
                          form[field][fieldInside]["type"] !== "Comercial"
                        ) {
                          return true
                        }
                        if (
                          form[field][fieldInside][fieldArray] === "" &&
                          fieldArray !== "relationship"
                        ) {
                          return true
                        }
                      }
                    }
                  }
                  if (
                    fieldInside !== "administrationCost" &&
                    form[field][fieldInside] === ""
                  ) {
                    return true
                  }
                }
              }
            } else {
              if (form[field] === "") {
                //console.log(`1. ${field}: ${form[field]}`);
                return true
              }
            }
            break
          case "Independiente":
            if (
              typeof form[field] === "object" &&
              field !== "vehicles" &&
              field !== "properties" &&
              field !== "finantialInformation" &&
              field !== "employee" &&
              field !== "pensionary" &&
              form[field] !== null
            ) {
              for (const fieldInside in form[field]) {
                if (form[field].hasOwnProperty(fieldInside)) {
                  //console.log(`Independiente ${fieldInside}x2: ${form[field][fieldInside]}`);
                  //console.log(`type: ${form.userType}`);

                  if (
                    typeof form[field][fieldInside] === "object" &&
                    form[field][fieldInside] !== null
                  ) {
                    for (const fieldArray in form[field][fieldInside]) {
                      if (form[field][fieldInside].hasOwnProperty(fieldArray)) {
                        console.log(
                          `Independiente ${fieldArray}x3: ${form[field][fieldInside][fieldArray]}`,
                        )
                        console.log(`type: ${form[field][fieldInside]["type"]}`)

                        if (
                          fieldArray === "relationship" &&
                          form[field][fieldInside][fieldArray] === "" &&
                          form[field][fieldInside]["type"] !== "Comercial"
                        ) {
                          return true
                        }
                        if (
                          form[field][fieldInside][fieldArray] === "" &&
                          fieldArray !== "relationship"
                        ) {
                          return true
                        }
                      }
                    }
                  }
                  if (
                    fieldInside !== "administrationCost" &&
                    form[field][fieldInside] === ""
                  ) {
                    return true
                  }
                }
              }
            } else {
              if (form[field] === "") {
                return true
              }
            }
            break
          case "Pensionado":
            if (
              typeof form[field] === "object" &&
              field !== "vehicles" &&
              field !== "properties" &&
              field !== "finantialInformation" &&
              field !== "employee" &&
              field !== "independent" &&
              form[field] !== null
            ) {
              for (const fieldInside in form[field]) {
                if (form[field].hasOwnProperty(fieldInside)) {
                  //console.log(`Pensionado ${fieldInside}x2: ${form[field][fieldInside]}`);
                  //console.log(`type: ${form.userType}`);

                  if (
                    typeof form[field][fieldInside] === "object" &&
                    form[field][fieldInside] !== null
                  ) {
                    for (const fieldArray in form[field][fieldInside]) {
                      if (form[field][fieldInside].hasOwnProperty(fieldArray)) {
                        console.log(
                          `Pensionado ${fieldArray}x3: ${form[field][fieldInside][fieldArray]}`,
                        )
                        console.log(`type: ${form[field][fieldInside]["type"]}`)

                        if (
                          fieldArray === "relationship" &&
                          form[field][fieldInside][fieldArray] === "" &&
                          form[field][fieldInside]["type"] !== "Comercial"
                        ) {
                          return true
                        }
                        if (
                          form[field][fieldInside][fieldArray] === "" &&
                          fieldArray !== "relationship"
                        ) {
                          return true
                        }
                      }
                    }
                  }
                  if (
                    fieldInside !== "administrationCost" &&
                    form[field][fieldInside] === ""
                  ) {
                    return true
                  }
                }
              }
            } else {
              if (form[field] === "") {
                return true
              }
            }
            break
          default:
            return true
        }
      }
    }
    return false
  }

  const getMissingFields = () => {
    const sections = {
      "Datos Personales": [],
      "Vivienda Actual": [],
      "Ocupación Laboral": [],
      Referencias: [],
      Codeudores: [],
      "Términos y Políticas": [],
    }

    const fieldLabels = {
      firstName: "Nombres",
      lastName: "Apellidos",
      documentType: "Tipo de documento",
      document: "Número de documento",
      email: "Correo electrónico",
      phone: "Teléfono",
      occupation: "Ocupación",
      dependents: "Personas a cargo",
      peopleWhoWillLive: "No. personas en el hogar",
      monthlyIncome: "Ingresos mensuales",
      monthlyExpenses: "Gastos mensuales",
      userType: "Tipo de persona",
    }

    const actualPropertyLabels = {
      type: "Tipo de propiedad actual",
      address: "Dirección de vivienda actual",
      neighborhood: "Barrio",
      actualPropertyProvince: "Departamento",
      actualPropertyCity: "Ciudad",
      landlord: "Propietario/Administrador",
      landlordPhone: "Teléfono del propietario",
      monthlyCost: "Costo mensual",
      antiquity: "Antigüedad en la vivienda",
    }

    const employeeLabels = {
      company: "Empresa",
      address: "Dirección de la empresa",
      position: "Cargo",
      salary: "Salario",
      admissionDay: "Fecha de ingreso",
    }

    const independentLabels = {
      activity: "Actividad económica",
      address: "Dirección del negocio",
      employeesNumber: "Cantidad de empleados",
      income: "Ingresos mensuales",
      expenses: "Gastos mensuales",
    }

    const pensionaryLabels = {
      reason: "Motivo de pensión",
      value: "Valor de pensión",
    }

    // Campos generales
    if (!form.firstName)
      sections["Datos Personales"].push(fieldLabels.firstName)
    if (!form.lastName) sections["Datos Personales"].push(fieldLabels.lastName)
    if (!form.documentType)
      sections["Datos Personales"].push(fieldLabels.documentType)
    if (!form.document) sections["Datos Personales"].push(fieldLabels.document)
    if (!form.email || !form.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
      sections["Datos Personales"].push(fieldLabels.email)
    if (!form.phone) sections["Datos Personales"].push(fieldLabels.phone)
    if (!form.occupation)
      sections["Datos Personales"].push(fieldLabels.occupation)
    if (!form.dependents)
      sections["Datos Personales"].push(fieldLabels.dependents)
    if (!form.peopleWhoWillLive)
      sections["Datos Personales"].push(fieldLabels.peopleWhoWillLive)
    if (!form.monthlyIncome)
      sections["Datos Personales"].push(fieldLabels.monthlyIncome)
    if (!form.monthlyExpenses)
      sections["Datos Personales"].push(fieldLabels.monthlyExpenses)

    // Vivienda actual
    if (!form.actualProperty.type)
      sections["Vivienda Actual"].push(actualPropertyLabels.type)
    if (!form.actualProperty.address)
      sections["Vivienda Actual"].push(actualPropertyLabels.address)
    if (!form.actualProperty.neighborhood)
      sections["Vivienda Actual"].push(actualPropertyLabels.neighborhood)
    if (!form.actualProperty.actualPropertyProvince)
      sections["Vivienda Actual"].push(
        actualPropertyLabels.actualPropertyProvince,
      )
    if (!form.actualProperty.actualPropertyCity)
      sections["Vivienda Actual"].push(actualPropertyLabels.actualPropertyCity)
    if (!form.actualProperty.landlord)
      sections["Vivienda Actual"].push(actualPropertyLabels.landlord)
    if (!form.actualProperty.landlordPhone)
      sections["Vivienda Actual"].push(actualPropertyLabels.landlordPhone)
    if (!form.actualProperty.monthlyCost)
      sections["Vivienda Actual"].push(actualPropertyLabels.monthlyCost)
    if (!form.actualProperty.antiquity)
      sections["Vivienda Actual"].push(actualPropertyLabels.antiquity)

    // Información según tipo de persona
    if (!form.userType || form.userType === "") {
      sections["Ocupación Laboral"].push(fieldLabels.userType)
    } else {
      if (form.userType === "Empleado") {
        if (!form.employee.company)
          sections["Ocupación Laboral"].push(employeeLabels.company)
        if (!form.employee.address)
          sections["Ocupación Laboral"].push(employeeLabels.address)
        if (!form.employee.position)
          sections["Ocupación Laboral"].push(employeeLabels.position)
        if (!form.employee.salary)
          sections["Ocupación Laboral"].push(employeeLabels.salary)
        if (!form.employee.admissionDay)
          sections["Ocupación Laboral"].push(employeeLabels.admissionDay)
      } else if (form.userType === "Independiente") {
        if (!form.independent.activity)
          sections["Ocupación Laboral"].push(independentLabels.activity)
        if (!form.independent.address)
          sections["Ocupación Laboral"].push(independentLabels.address)
        if (!form.independent.employeesNumber)
          sections["Ocupación Laboral"].push(independentLabels.employeesNumber)
        if (!form.independent.income)
          sections["Ocupación Laboral"].push(independentLabels.income)
        if (!form.independent.expenses)
          sections["Ocupación Laboral"].push(independentLabels.expenses)
      } else if (form.userType === "Pensionado") {
        if (!form.pensionary.reason)
          sections["Ocupación Laboral"].push(pensionaryLabels.reason)
        if (!form.pensionary.value)
          sections["Ocupación Laboral"].push(pensionaryLabels.value)
      }
    }

    // Referencias
    for (let i = 0; i < form.references.length; i++) {
      const ref = form.references[i]
      if (!ref.fullname)
        sections["Referencias"].push(`${ref.type} - Nombre completo`)
      if (!ref.phone) sections["Referencias"].push(`${ref.type} - Teléfono`)
      if (ref.type !== "Comercial" && !ref.relationship) {
        sections["Referencias"].push(`${ref.type} - Relación`)
      }
    }

    // Codeudores
    if (form.cosigners && form.cosigners.length > 0) {
      for (let i = 0; i < form.cosigners.length; i++) {
        const cosigner = form.cosigners[i]
        if (!cosigner.firstName)
          sections["Codeudores"].push(`Codeudor ${i + 1} - Nombres`)
        if (!cosigner.lastName)
          sections["Codeudores"].push(`Codeudor ${i + 1} - Apellidos`)
        if (!cosigner.documentType)
          sections["Codeudores"].push(`Codeudor ${i + 1} - Tipo de documento`)
        if (!cosigner.document)
          sections["Codeudores"].push(`Codeudor ${i + 1} - Número de documento`)
        if (
          !cosigner.email ||
          !cosigner.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
        )
          sections["Codeudores"].push(`Codeudor ${i + 1} - Correo electrónico`)
        if (!cosigner.phone)
          sections["Codeudores"].push(`Codeudor ${i + 1} - Teléfono`)
        if (!cosigner.cosignerProvince)
          sections["Codeudores"].push(`Codeudor ${i + 1} - Departamento`)
        if (!cosigner.cosignerCity)
          sections["Codeudores"].push(`Codeudor ${i + 1} - Ciudad`)
        if (!cosigner.address)
          sections["Codeudores"].push(`Codeudor ${i + 1} - Dirección`)
      }
    }

    // Términos
    if (!form.acceptTerms)
      sections["Términos y Políticas"].push(
        "Aceptar política de tratamiento de datos",
      )
    if (!form.description)
      sections["Términos y Políticas"].push("Descripción de origen de fondos")

    return sections
  }

  const createFunction = (data) => {
    if (data.code === "01") {
      setLoadData(true)
      alert("Error", data.message)
      return
    }

    setLoadData(true)
    //console.log(data);
    alert(
      "¡Éxito!",
      "Solicitud creada con éxito, pronto se prondrán en contacto con usted, muchas gracias",
    )

    // Reset form and states after successful submission
    setIsSubmitted(false)
    setMissingFields({})
    setCurrentStep(0)
    setForm({
      firstName: "",
      lastName: "",
      documentType: "",
      document: "",
      email: "",
      phone: "",
      occupation: "",
      dependents: "",
      peopleWhoWillLive: "",
      monthlyExpenses: "",
      monthlyIncome: "",
      actualProperty: {
        type: "",
        address: "",
        neighborhood: "",
        actualPropertyProvince: "",
        actualPropertyCity: "",
        landlord: "",
        landlordPhone: "",
        monthlyCost: "",
        administrationCost: "",
        antiquity: "",
      },
      userType: "Empleado",
      employee: {
        company: "",
        address: "",
        position: "",
        salary: "",
        admissionDay: "",
      },
      independent: {
        activity: "",
        address: "",
        employeesNumber: "",
        income: "",
        expenses: "",
      },
      pensionary: {
        reason: "",
        value: "",
      },
      properties: [{ ...propertyObj }],
      vehicles: [{ ...vehicleObj }],
      finantialInformation: [{ ...finantialObj }],
      references: [
        {
          type: "Familiar",
          fullname: "",
          phone: "",
          relationship: "",
        },
        {
          type: "Personal",
          fullname: "",
          phone: "",
          relationship: "",
        },
        {
          type: "Comercial",
          fullname: "",
          phone: "",
          relationship: "",
        },
        {
          type: "Comercial",
          fullname: "",
          phone: "",
          relationship: "",
        },
      ],
      cosigners: [],
      description: "",
      acceptTerms: false,
    })
  }

  // Actualizar lista de campos faltantes en tiempo real después de intentar enviar
  useEffect(() => {
    if (isSubmitted) {
      const missingFieldsList = getMissingFields()
      setMissingFields(missingFieldsList)
    }
  }, [form, isSubmitted])

  // Función para renderizar paso actual
  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return renderGeneralDataStep()
      case 1:
        return renderCurrentPropertyStep()
      case 2:
        return renderOccupationStep()
      case 3:
        return renderAssetsStep()
      case 4:
        return renderFinancialStep()
      case 5:
        return renderReferencesStep()
      case 6:
        return renderTermsStep()
      default:
        return null
    }
  }

  // Paso 0: Datos Generales
  const renderGeneralDataStep = () => (
    <div className="form-step">
      <div className="step-header">
        <BsPersonFill className="step-icon" />
        <div>
          <h2>Datos Personales</h2>
          <p>Información básica del solicitante</p>
        </div>
      </div>
      <div className="step-content">
        <div className="field-row">
          <CreateField
            fieldValue={form.firstName}
            parentHandleChange={handleInputChange}
            isSubmitted={isSubmitted}
            config={{
              inputID: "firstName",
              labelText: "Nombres *",
            }}
          />
          <CreateField
            fieldValue={form.lastName}
            parentHandleChange={handleInputChange}
            isSubmitted={isSubmitted}
            config={{
              inputID: "lastName",
              labelText: "Apellidos *",
            }}
          />
        </div>

        <div className="field-row">
          <CreateField
            fieldType={2}
            fieldValue={form.documentType}
            parentHandleChange={handleInputChange}
            isSubmitted={isSubmitted}
            config={{
              inputID: "documentType",
              labelText: "Tipo de documento *",
              options: documentTypes,
            }}
          />
          <CreateField
            fieldValue={form.document}
            parentHandleChange={handleInputChange}
            isSubmitted={isSubmitted}
            config={{
              inputID: "document",
              labelText: "Documento *",
              type: "number",
              maxLength: 15,
            }}
          />
        </div>

        <div className="field-row">
          <CreateField
            fieldValue={form.email}
            parentHandleChange={handleInputChange}
            isSubmitted={isSubmitted}
            config={{
              inputID: "email",
              labelText: "Email *",
              type: "email",
            }}
          />
          <CreateField
            fieldValue={form.phone}
            parentHandleChange={handleInputChange}
            isSubmitted={isSubmitted}
            config={{
              inputID: "phone",
              labelText: "Celular *",
              type: "number",
              maxLength: 15,
            }}
          />
        </div>

        <div className="field-row">
          <CreateField
            fieldValue={form.occupation}
            parentHandleChange={handleInputChange}
            isSubmitted={isSubmitted}
            config={{
              inputID: "occupation",
              labelText: "Ocupación *",
            }}
          />
          <CreateField
            fieldValue={form.dependents}
            parentHandleChange={handleInputChange}
            isSubmitted={isSubmitted}
            config={{
              inputID: "dependents",
              labelText: "Personas a cargo *",
              type: "number",
            }}
          />
        </div>

        <div className="field-row">
          <CreateField
            fieldValue={form.peopleWhoWillLive}
            parentHandleChange={handleInputChange}
            isSubmitted={isSubmitted}
            config={{
              inputID: "peopleWhoWillLive",
              labelText: "No. personas en el hogar *",
              type: "number",
            }}
          />
          <CreateField
            fieldValue={form.monthlyIncome}
            parentHandleChange={handleInputChange}
            isSubmitted={isSubmitted}
            config={{
              inputID: "monthlyIncome",
              labelText: "Ingresos mensuales *",
              type: "number",
            }}
          />
        </div>

        <div className="field-row">
          <CreateField
            fieldValue={form.monthlyExpenses}
            parentHandleChange={handleInputChange}
            isSubmitted={isSubmitted}
            config={{
              inputID: "monthlyExpenses",
              labelText: "Gastos mensuales *",
              type: "number",
            }}
          />
        </div>
      </div>
    </div>
  )

  // Paso 1: Vivienda Actual
  const renderCurrentPropertyStep = () => (
    <div className="form-step">
      <div className="step-header">
        <BsHouseFill className="step-icon" />
        <div>
          <h2>Vivienda Actual</h2>
          <p>Información sobre tu residencia actual</p>
        </div>
      </div>
      <div className="step-content">
        <div className="field-row">
          <div
            className={`form-field ${checkInsideEmptyfield(
              "actualProperty",
              "type",
            )}`}
          >
            <label>Tipo de propiedad *</label>
            <select
              name="type"
              onChange={(e) => handleInsideInputChange("actualProperty", e)}
              value={form.actualProperty.type}
            >
              <option value="">Seleccionar</option>
              {actualPropertyTypes.map((type, index) => (
                <option key={index} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
          <div
            className={`form-field ${checkInsideEmptyfield(
              "actualProperty",
              "address",
            )}`}
          >
            <label>Dirección *</label>
            <input
              type="text"
              name="address"
              onChange={(e) => handleInsideInputChange("actualProperty", e)}
              value={form.actualProperty.address}
              maxLength={150}
            />
          </div>
        </div>

        <div className="field-row">
          <div
            className={`form-field ${checkInsideEmptyfield(
              "actualProperty",
              "neighborhood",
            )}`}
          >
            <label>Barrio *</label>
            <input
              type="text"
              name="neighborhood"
              onChange={(e) => handleInsideInputChange("actualProperty", e)}
              value={form.actualProperty.neighborhood}
              maxLength={100}
            />
          </div>
          <div
            className={`form-field ${checkInsideEmptyfield(
              "actualProperty",
              "actualPropertyProvince",
            )}`}
          >
            <label>Departamento *</label>
            <select
              name="actualPropertyProvince"
              onChange={handleOnChange}
              value={form.actualProperty.actualPropertyProvince}
            >
              <option value="">Seleccionar</option>
              {provinces.map((province) => (
                <option key={province.name} value={province.name}>
                  {province.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {form.actualProperty.actualPropertyProvince &&
          citiesData.actualPropertyCities.length > 0 && (
            <div className="field-row">
              <div
                className={`form-field ${checkInsideEmptyfield(
                  "actualProperty",
                  "actualPropertyCity",
                )}`}
              >
                <label>Ciudad *</label>
                <select
                  name="actualPropertyCity"
                  onChange={(e) => handleInsideInputChange("actualProperty", e)}
                  value={form.actualProperty.actualPropertyCity}
                >
                  <option value="">Seleccionar</option>
                  {citiesData.actualPropertyCities.map((city) => (
                    <option key={city.name} value={city.name}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

        <div className="field-row">
          <div
            className={`form-field ${checkInsideEmptyfield(
              "actualProperty",
              "landlord",
            )}`}
          >
            <label>Administrador/Propietario *</label>
            <input
              type="text"
              name="landlord"
              onChange={(e) => handleInsideInputChange("actualProperty", e)}
              value={form.actualProperty.landlord}
              maxLength={150}
            />
          </div>
          <div
            className={`form-field ${checkInsideEmptyfield(
              "actualProperty",
              "landlordPhone",
            )}`}
          >
            <label>Celular del Administrador *</label>
            <input
              type="number"
              name="landlordPhone"
              onChange={(e) => handleInsideInputChange("actualProperty", e)}
              value={form.actualProperty.landlordPhone}
              maxLength={15}
            />
          </div>
        </div>

        <div className="field-row">
          <div
            className={`form-field ${checkInsideEmptyfield(
              "actualProperty",
              "monthlyCost",
            )}`}
          >
            <label>Costo mensual *</label>
            <input
              type="number"
              name="monthlyCost"
              onChange={(e) => handleInsideInputChange("actualProperty", e)}
              value={form.actualProperty.monthlyCost}
              maxLength={15}
            />
          </div>
          <div className="form-field">
            <label>Costo administración (opcional)</label>
            <input
              type="number"
              name="administrationCost"
              onChange={(e) => handleInsideInputChange("actualProperty", e)}
              value={form.actualProperty.administrationCost}
              maxLength={15}
            />
          </div>
          <div
            className={`form-field ${checkInsideEmptyfield(
              "actualProperty",
              "antiquity",
            )}`}
          >
            <label>Antigüedad (años) *</label>
            <input
              type="text"
              name="antiquity"
              onChange={(e) => handleInsideInputChange("actualProperty", e)}
              value={form.actualProperty.antiquity}
            />
          </div>
        </div>
      </div>
    </div>
  )

  // Paso 2: Ocupación
  const renderOccupationStep = () => (
    <div className="form-step">
      <div className="step-header">
        <BsBriefcaseFill className="step-icon" />
        <div>
          <h2>Información Laboral</h2>
          <p>Detalles de tu situación laboral</p>
        </div>
      </div>
      <div className="step-content">
        <div className="field-row">
          <div className={`form-field ${checkEmptyfield("userType")}`}>
            <label>Tipo de empleado *</label>
            <select
              name="userType"
              onChange={handleInputChange}
              value={form.userType}
            >
              <option value="">Seleccionar</option>
              {requestTypes.map((type, index) => (
                <option key={index}>{type}</option>
              ))}
            </select>
          </div>
        </div>

        {form.userType === "Empleado" && (
          <>
            <div className="subsection-title">Información del Empleado</div>
            <div className="field-row">
              <div
                className={`form-field ${checkInsideEmptyfield(
                  "employee",
                  "company",
                )}`}
              >
                <label>Empresa *</label>
                <input
                  type="text"
                  name="company"
                  onChange={(e) => handleInsideInputChange("employee", e)}
                  value={form.employee.company}
                  maxLength={150}
                />
              </div>
              <div
                className={`form-field ${checkInsideEmptyfield(
                  "employee",
                  "position",
                )}`}
              >
                <label>Cargo *</label>
                <input
                  type="text"
                  name="position"
                  onChange={(e) => handleInsideInputChange("employee", e)}
                  value={form.employee.position}
                  maxLength={100}
                />
              </div>
            </div>
            <div className="field-row">
              <div
                className={`form-field ${checkInsideEmptyfield(
                  "employee",
                  "address",
                )}`}
              >
                <label>Dirección empresa *</label>
                <input
                  type="text"
                  name="address"
                  onChange={(e) => handleInsideInputChange("employee", e)}
                  value={form.employee.address}
                  maxLength={150}
                />
              </div>
              <div
                className={`form-field ${checkInsideEmptyfield(
                  "employee",
                  "salary",
                )}`}
              >
                <label>Salario *</label>
                <input
                  type="number"
                  name="salary"
                  onChange={(e) => handleInsideInputChange("employee", e)}
                  value={form.employee.salary}
                  min={1}
                />
              </div>
            </div>
            <div className="field-row">
              <div
                className={`form-field ${checkInsideEmptyfield(
                  "employee",
                  "admissionDay",
                )}`}
              >
                <label>Fecha de ingreso *</label>
                <DateInput
                  name="admissionDay"
                  value={form.employee.admissionDay}
                  onChange={(date) => handleDateChange("admissionDay", date)}
                />
              </div>
            </div>
          </>
        )}

        {form.userType === "Independiente" && (
          <>
            <div className="subsection-title">
              Información del Independiente
            </div>
            <div className="field-row">
              <div
                className={`form-field ${checkInsideEmptyfield(
                  "independent",
                  "activity",
                )}`}
              >
                <label>Actividad principal *</label>
                <input
                  type="text"
                  name="activity"
                  onChange={(e) => handleInsideInputChange("independent", e)}
                  value={form.independent.activity}
                  maxLength={150}
                />
              </div>
              <div
                className={`form-field ${checkInsideEmptyfield(
                  "independent",
                  "address",
                )}`}
              >
                <label>Dirección negocio *</label>
                <input
                  type="text"
                  name="address"
                  onChange={(e) => handleInsideInputChange("independent", e)}
                  value={form.independent.address}
                  maxLength={150}
                />
              </div>
            </div>
            <div className="field-row">
              <div
                className={`form-field ${checkInsideEmptyfield(
                  "independent",
                  "employeesNumber",
                )}`}
              >
                <label>No. empleados a cargo *</label>
                <input
                  type="number"
                  name="employeesNumber"
                  onChange={(e) => handleInsideInputChange("independent", e)}
                  value={form.independent.employeesNumber}
                />
              </div>
              <div
                className={`form-field ${checkInsideEmptyfield(
                  "independent",
                  "income",
                )}`}
              >
                <label>Ingresos mensuales *</label>
                <input
                  type="number"
                  name="income"
                  onChange={(e) => handleInsideInputChange("independent", e)}
                  value={form.independent.income}
                  min={1}
                />
              </div>
            </div>
            <div className="field-row">
              <div
                className={`form-field ${checkInsideEmptyfield(
                  "independent",
                  "expenses",
                )}`}
              >
                <label>Egresos mensuales *</label>
                <input
                  type="text"
                  name="expenses"
                  onChange={(e) => handleInsideInputChange("independent", e)}
                  value={form.independent.expenses}
                  maxLength={100}
                />
              </div>
            </div>
          </>
        )}

        {form.userType === "Pensionado" && (
          <>
            <div className="subsection-title">Información del Pensionado</div>
            <div className="field-row">
              <div
                className={`form-field ${checkInsideEmptyfield(
                  "pensionary",
                  "reason",
                )}`}
              >
                <label>Razón de la pensión *</label>
                <input
                  type="text"
                  name="reason"
                  onChange={(e) => handleInsideInputChange("pensionary", e)}
                  value={form.pensionary.reason}
                  placeholder="Describa la razón por la cual fue pensionado/a"
                  maxLength={150}
                />
              </div>
              <div
                className={`form-field ${checkInsideEmptyfield(
                  "pensionary",
                  "value",
                )}`}
              >
                <label>Valor de la pensión *</label>
                <input
                  type="text"
                  name="value"
                  onChange={(e) => handleInsideInputChange("pensionary", e)}
                  value={form.pensionary.value}
                  maxLength={150}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )

  // Paso 3: Activos (Propiedades y Vehículos)
  const renderAssetsStep = () => (
    <div className="form-step">
      <div className="step-header">
        <BsBuilding className="step-icon" />
        <div>
          <h2>Activos</h2>
          <p>Propiedades y vehículos (opcional)</p>
        </div>
      </div>
      <div className="step-content">
        {/* Propiedades */}
        <div className="subsection-title">
          <BsHouseFill style={{ marginRight: "0.5rem" }} /> Propiedades
        </div>
        {form.properties.map((property, index) => (
          <div key={index} className="dynamic-section">
            <div className="section-header">
              <span>Propiedad {index + 1}</span>
              {form.properties.length > 1 && (
                <button
                  type="button"
                  className="delete-btn"
                  onClick={() => deleteObj("properties", index)}
                >
                  ✕
                </button>
              )}
            </div>
            <div className="field-row">
              <div className="form-field">
                <label>Tipo de propiedad</label>
                <select
                  name="type"
                  onChange={(e) =>
                    handleDynamicInputChange("properties", index, e)
                  }
                  value={property.type}
                >
                  <option value="">Seleccionar</option>
                  {propertyTypes.map((type, idx) => (
                    <option key={idx} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-field">
                <label>Dirección</label>
                <input
                  type="text"
                  name="address"
                  onChange={(e) =>
                    handleDynamicInputChange("properties", index, e)
                  }
                  value={property.address}
                  maxLength={150}
                />
              </div>
            </div>
            <div className="field-row">
              <div className="form-field">
                <label>Departamento</label>
                <select
                  name="propertyProvince"
                  onChange={(e) =>
                    handleDynamicOnChange(
                      "properties",
                      "propertiesCities",
                      index,
                      e,
                    )
                  }
                  value={property.propertyProvince}
                >
                  <option value="">Seleccionar</option>
                  {provinces.map((province) => (
                    <option key={province.name} value={province.name}>
                      {province.name}
                    </option>
                  ))}
                </select>
              </div>
              {property.propertyProvince &&
                citiesData.propertiesCities[index]?.length > 0 && (
                  <div className="form-field">
                    <label>Ciudad</label>
                    <select
                      name="propertyCity"
                      onChange={(e) =>
                        handleDynamicInputChange("properties", index, e)
                      }
                      value={property.propertyCity}
                    >
                      <option value="">Seleccionar</option>
                      {citiesData.propertiesCities[index].map((city) => (
                        <option key={city.name} value={city.name}>
                          {city.name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
            </div>
            <div className="field-row">
              <div className="form-field">
                <label>Valor</label>
                <input
                  type="number"
                  name="value"
                  onChange={(e) =>
                    handleDynamicInputChange("properties", index, e)
                  }
                  value={property.value}
                  maxLength={100}
                />
              </div>
              <div className="form-field">
                <label>Matrícula inmobiliaria</label>
                <input
                  type="text"
                  name="realEstateRegistration"
                  onChange={(e) =>
                    handleDynamicInputChange("properties", index, e)
                  }
                  value={property.realEstateRegistration}
                  maxLength={150}
                />
              </div>
            </div>
          </div>
        ))}
        <button
          type="button"
          className="add-btn"
          onClick={() => addObj("properties")}
        >
          + Agregar Propiedad
        </button>

        {/* Vehículos */}
        <div className="subsection-title" style={{ marginTop: "2rem" }}>
          <BsCarFront style={{ marginRight: "0.5rem" }} /> Vehículos
        </div>
        {form.vehicles.map((vehicle, index) => (
          <div key={index} className="dynamic-section">
            <div className="section-header">
              <span>Vehículo {index + 1}</span>
              {form.vehicles.length > 1 && (
                <button
                  type="button"
                  className="delete-btn"
                  onClick={() => deleteObj("vehicles", index)}
                >
                  ✕
                </button>
              )}
            </div>
            <div className="field-row">
              <div className="form-field">
                <label>Tipo</label>
                <select
                  name="type"
                  onChange={(e) =>
                    handleDynamicInputChange("vehicles", index, e)
                  }
                  value={vehicle.type}
                >
                  <option value="">Seleccionar</option>
                  {vehicleTypes.map((type, idx) => (
                    <option key={idx} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-field">
                <label>Marca</label>
                <input
                  type="text"
                  name="brand"
                  onChange={(e) =>
                    handleDynamicInputChange("vehicles", index, e)
                  }
                  value={vehicle.brand}
                  maxLength={150}
                />
              </div>
              <div className="form-field">
                <label>Modelo</label>
                <input
                  type="text"
                  name="model"
                  onChange={(e) =>
                    handleDynamicInputChange("vehicles", index, e)
                  }
                  value={vehicle.model}
                  maxLength={150}
                />
              </div>
              <div className="form-field">
                <label>Placa</label>
                <input
                  type="text"
                  name="plaque"
                  onChange={(e) =>
                    handleDynamicInputChange("vehicles", index, e)
                  }
                  value={vehicle.plaque}
                  maxLength={150}
                />
              </div>
            </div>
          </div>
        ))}
        <button
          type="button"
          className="add-btn"
          onClick={() => addObj("vehicles")}
        >
          + Agregar Vehículo
        </button>
      </div>
    </div>
  )

  // Paso 4: Información Financiera
  const renderFinancialStep = () => (
    <div className="form-step">
      <div className="step-header">
        <BsCurrencyDollar className="step-icon" />
        <div>
          <h2>Información Financiera</h2>
          <p>Obligaciones vigentes (opcional)</p>
        </div>
      </div>
      <div className="step-content">
        {form.finantialInformation.map((information, index) => (
          <div key={index} className="dynamic-section">
            <div className="section-header">
              <span>Obligación {index + 1}</span>
              {form.finantialInformation.length > 1 && (
                <button
                  type="button"
                  className="delete-btn"
                  onClick={() => deleteObj("finantialInformation", index)}
                >
                  ✕
                </button>
              )}
            </div>
            <div className="field-row">
              <div className="form-field">
                <label>Tipo de obligación</label>
                <select
                  name="type"
                  onChange={(e) =>
                    handleDynamicInputChange("finantialInformation", index, e)
                  }
                  value={information.type}
                >
                  <option value="">Seleccionar</option>
                  {finantialInformationType.map((type, idx) => (
                    <option key={idx} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-field">
                <label>Entidad</label>
                <input
                  type="text"
                  name="entity"
                  onChange={(e) =>
                    handleDynamicInputChange("finantialInformation", index, e)
                  }
                  value={information.entity}
                  maxLength={150}
                />
              </div>
            </div>
            <div className="field-row">
              <div className="form-field">
                <label>Valor total</label>
                <input
                  type="number"
                  name="value"
                  onChange={(e) =>
                    handleDynamicInputChange("finantialInformation", index, e)
                  }
                  value={information.value}
                  maxLength={100}
                />
              </div>
              <div className="form-field">
                <label>Valor cuota</label>
                <input
                  type="number"
                  name="fee"
                  onChange={(e) =>
                    handleDynamicInputChange("finantialInformation", index, e)
                  }
                  value={information.fee}
                  maxLength={150}
                />
              </div>
              <div className="form-field">
                <label>Valor restante</label>
                <input
                  type="number"
                  name="remaining"
                  onChange={(e) =>
                    handleDynamicInputChange("finantialInformation", index, e)
                  }
                  value={information.remaining}
                  maxLength={150}
                />
              </div>
            </div>
          </div>
        ))}
        <button
          type="button"
          className="add-btn"
          onClick={() => addObj("finantialInformation")}
        >
          + Agregar Obligación
        </button>
      </div>
    </div>
  )

  // Paso 5: Referencias y Codeudores
  const renderReferencesStep = () => (
    <div className="form-step">
      <div className="step-header">
        <BsPhone className="step-icon" />
        <div>
          <h2>Referencias y Codeudores</h2>
          <p>Información de contactos y avalistas</p>
        </div>
      </div>
      <div className="step-content">
        {/* Referencias */}
        <div className="subsection-title">Referencias</div>
        <p className="help-text">
          Se requiere una familiar, una personal y 2 comerciales
        </p>
        {form.references.map((reference, index) => (
          <div key={index} className="dynamic-section">
            <div className="section-header">
              <span>{reference.type}</span>
            </div>
            <div className="field-row">
              <div
                className={`form-field ${checkDynamicEmptyField(
                  "references",
                  index,
                  "fullname",
                )}`}
              >
                <label>Nombres completos *</label>
                <input
                  type="text"
                  name="fullname"
                  onChange={(e) =>
                    handleDynamicInputChange("references", index, e)
                  }
                  value={reference.fullname}
                  maxLength={180}
                />
              </div>
              <div
                className={`form-field ${checkDynamicEmptyField(
                  "references",
                  index,
                  "phone",
                )}`}
              >
                <label>Celular *</label>
                <input
                  type="number"
                  name="phone"
                  onChange={(e) =>
                    handleDynamicInputChange("references", index, e)
                  }
                  value={reference.phone}
                  maxLength={15}
                />
              </div>
            </div>
            {reference.type !== "Comercial" && (
              <div className="field-row">
                <div
                  className={`form-field ${checkDynamicEmptyField(
                    "references",
                    index,
                    "relationship",
                  )}`}
                >
                  <label>Parentesco/Relación *</label>
                  <input
                    type="text"
                    name="relationship"
                    onChange={(e) =>
                      handleDynamicInputChange("references", index, e)
                    }
                    value={reference.relationship}
                    maxLength={150}
                  />
                </div>
              </div>
            )}
          </div>
        ))}

        {/* Codeudores */}
        <div className="subsection-title" style={{ marginTop: "2rem" }}>
          Codeudores
        </div>
        <p className="help-text">Puede agregar más si lo desea</p>
        {form.cosigners.map((cosigner, index) => (
          <div key={index} className="dynamic-section">
            <div className="section-header">
              <span>Codeudor {index + 1}</span>
              {form.cosigners.length > 1 && (
                <button
                  type="button"
                  className="delete-btn"
                  onClick={() => deleteCosigner(index)}
                >
                  ✕
                </button>
              )}
            </div>
            <div className="field-row">
              <div
                className={`form-field ${checkDynamicEmptyField(
                  "cosigners",
                  index,
                  "firstName",
                )}`}
              >
                <label>Nombres *</label>
                <input
                  type="text"
                  name="firstName"
                  onChange={(e) =>
                    handleDynamicInputChange("cosigners", index, e)
                  }
                  value={cosigner.firstName}
                  maxLength={100}
                />
              </div>
              <div
                className={`form-field ${checkDynamicEmptyField(
                  "cosigners",
                  index,
                  "lastName",
                )}`}
              >
                <label>Apellidos *</label>
                <input
                  type="text"
                  name="lastName"
                  onChange={(e) =>
                    handleDynamicInputChange("cosigners", index, e)
                  }
                  value={cosigner.lastName}
                  maxLength={100}
                />
              </div>
            </div>
            <div className="field-row">
              <div
                className={`form-field ${checkDynamicEmptyField(
                  "cosigners",
                  index,
                  "documentType",
                )}`}
              >
                <label>Tipo de documento *</label>
                <select
                  name="documentType"
                  onChange={(e) =>
                    handleDynamicInputChange("cosigners", index, e)
                  }
                  value={cosigner.documentType}
                >
                  <option value="">Seleccionar</option>
                  {documentTypes.map((type, idx) => (
                    <option key={idx} value={type.name || type}>
                      {type.name || type}
                    </option>
                  ))}
                </select>
              </div>
              <div
                className={`form-field ${checkDynamicEmptyField(
                  "cosigners",
                  index,
                  "document",
                )}`}
              >
                <label>Documento *</label>
                <input
                  type="number"
                  name="document"
                  onChange={(e) =>
                    handleDynamicInputChange("cosigners", index, e)
                  }
                  value={cosigner.document}
                  maxLength={15}
                />
              </div>
            </div>
            <div className="field-row">
              <div
                className={`form-field ${checkDynamicEmptyField(
                  "cosigners",
                  index,
                  "email",
                )}`}
              >
                <label>Email *</label>
                <input
                  type="email"
                  name="email"
                  onChange={(e) =>
                    handleDynamicInputChange("cosigners", index, e)
                  }
                  value={cosigner.email}
                  maxLength={120}
                />
              </div>
              <div
                className={`form-field ${checkDynamicEmptyField(
                  "cosigners",
                  index,
                  "phone",
                )}`}
              >
                <label>Celular *</label>
                <input
                  type="number"
                  name="phone"
                  onChange={(e) =>
                    handleDynamicInputChange("cosigners", index, e)
                  }
                  value={cosigner.phone}
                  maxLength={15}
                />
              </div>
            </div>
            <div className="field-row">
              <div
                className={`form-field ${checkDynamicEmptyField(
                  "cosigners",
                  index,
                  "cosignerProvince",
                )}`}
              >
                <label>Departamento de residencia *</label>
                <select
                  name="cosignerProvince"
                  onChange={(e) =>
                    handleDynamicOnChange(
                      "cosigners",
                      "cosignersCities",
                      index,
                      e,
                    )
                  }
                  value={cosigner.cosignerProvince}
                >
                  <option value="">Seleccionar</option>
                  {provinces.map((province) => (
                    <option key={province.name} value={province.name}>
                      {province.name}
                    </option>
                  ))}
                </select>
              </div>
              {cosigner.cosignerProvince &&
                citiesData.cosignersCities[index]?.length > 0 && (
                  <div
                    className={`form-field ${checkDynamicEmptyField(
                      "cosigners",
                      index,
                      "cosignerCity",
                    )}`}
                  >
                    <label>Ciudad de residencia *</label>
                    <select
                      name="cosignerCity"
                      onChange={(e) =>
                        handleDynamicInputChange("cosigners", index, e)
                      }
                      value={cosigner.cosignerCity}
                    >
                      <option value="">Seleccionar</option>
                      {citiesData.cosignersCities[index].map((city) => (
                        <option key={city.name} value={city.name}>
                          {city.name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
            </div>
            <div className="field-row">
              <div
                className={`form-field ${checkDynamicEmptyField(
                  "cosigners",
                  index,
                  "address",
                )}`}
              >
                <label>Dirección residencia *</label>
                <input
                  type="text"
                  name="address"
                  onChange={(e) =>
                    handleDynamicInputChange("cosigners", index, e)
                  }
                  value={cosigner.address}
                  maxLength={150}
                />
              </div>
            </div>
          </div>
        ))}
        <button
          type="button"
          className="add-btn"
          onClick={() => addObj("cosigners")}
        >
          + Agregar Codeudor
        </button>
      </div>
    </div>
  )

  // Paso 6: Términos y Condiciones
  const renderTermsStep = () => (
    <div className="form-step">
      <div className="step-header">
        <BsFileEarmarkText className="step-icon" />
        <div>
          <h2>Requisitos y Términos</h2>
          <p>Información importante y confirmación</p>
        </div>
      </div>
      <div className="step-content">
        <div className="requirements-section">
          <h3>Requisitos por tu tipo de empleado</h3>
          <ul className="requirements-list">
            {requirements.map((requirement, index) => (
              <li key={index}>
                <BsCheckCircle className="requirement-icon" />
                {requirement}
              </li>
            ))}
          </ul>
          <p className="info-box">
            Todos los documentos deben ser enviados a:
            <strong>notificaciones@ayhgrupo.com</strong>
          </p>
          <p className="info-box warning">
            <strong>NOTA:</strong> Para acreditación de finca raíz de
            codeudores, se requiere certificado de tradición y libertad (sin
            limitaciones) y recibo de servicios públicos.
          </p>
        </div>

        <div className={`form-field ${checkEmptyfield("description")}`}>
          <label>Declaración de Veracidad *</label>
          <textarea
            value={form.description}
            onChange={handleInputChange}
            name="description"
            rows={4}
            placeholder={descriptionText}
          />
        </div>

        <div className={`checkbox-field ${checkEmptyfield("acceptTerms")}`}>
          <input
            type="checkbox"
            id="acceptTerms"
            name="acceptTerms"
            onChange={handleCheckChange}
            checked={form.acceptTerms}
          />
          <label htmlFor="acceptTerms">
            <span className="required">*</span> {acceptText}
          </label>
        </div>
      </div>
    </div>
  )

  return (
    <div className="request-page">
      {currentData && Object.keys(currentData).length > 0 && (
        <div className="request-wrapper">
          {/* Property Header */}
          <div className="property-header">
            <div className="property-info">
              <h1>Nueva Solicitud de Arrendamiento</h1>
              <div className="property-details">
                <div className="detail">
                  <span className="label">Ubicación</span>
                  <span className="value">{currentData.ubication}</span>
                </div>
                <div className="detail">
                  <span className="label">Tipo</span>
                  <span className="value">{currentData.propertyType}</span>
                </div>
                <div className="detail">
                  <span className="label">Valor mes</span>
                  <span className="value">
                    {stringToCurrency(currentData.monthCost)}
                  </span>
                </div>
                {currentData.hasAdministrationFee &&
                  !currentData.feeIncluded && (
                    <div className="detail">
                      <span className="label">Administración</span>
                      <span className="value">
                        {stringToCurrency(currentData.administrationCost)}
                      </span>
                    </div>
                  )}
              </div>
            </div>
            <img src={logo} alt="Logo" className="property-logo" />
          </div>

          {/* Progress Indicator */}
          <div className="progress-container">
            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${((currentStep + 1) / totalSteps) * 100}%` }}
              />
            </div>
            <div className="step-indicators">
              {Array.from({ length: totalSteps }).map((_, index) => (
                <div
                  key={index}
                  className={`step-indicator ${index === currentStep ? "active" : ""} ${index < currentStep ? "completed" : ""}`}
                  onClick={() => setCurrentStep(index)}
                  title={
                    [
                      "Datos Personales",
                      "Vivienda Actual",
                      "Ocupación",
                      "Activos",
                      "Financiera",
                      "Referencias",
                      "Términos",
                    ][index]
                  }
                >
                  {index < currentStep ? <BsCheckCircle /> : index + 1}
                </div>
              ))}
            </div>
          </div>

          {/* Form */}
          <form onSubmit={handleOnSubmit} className="form-container">
            {currentStep === totalSteps - 1 &&
              Object.values(missingFields).some(
                (fields) => fields.length > 0,
              ) && (
                <div className="error-message">
                  <div className="error-header">
                    <BsExclamationTriangle className="error-icon" />
                    <h3>Campos Incompletos</h3>
                  </div>
                  <div className="error-sections">
                    {Object.entries(missingFields).map(
                      ([section, fields]) =>
                        fields.length > 0 && (
                          <div key={section} className="error-section">
                            <h4>{section}</h4>
                            <ul>
                              {fields.map((field, index) => (
                                <li key={index}>{field}</li>
                              ))}
                            </ul>
                          </div>
                        ),
                    )}
                  </div>
                </div>
              )}
            {renderStep()}

            {/* Navigation Buttons */}
            <div className="form-navigation">
              <button
                type="button"
                className="nav-button prev-button"
                onClick={() => {
                  setCurrentStep(Math.max(0, currentStep - 1))
                  // Solo resetear si aún no ha intentado enviar
                  // Si ya intentó enviar, mantener el estado de errores en otros pasos
                  if (!isSubmitted) {
                    setMissingFields({})
                  }
                }}
                disabled={currentStep === 0}
              >
                <BsChevronLeft /> Anterior
              </button>

              <div className="button-group">
                {currentStep === totalSteps - 1 ? (
                  <button type="submit" className="nav-button submit-button">
                    <BsCheckCircle /> Enviar Solicitud
                  </button>
                ) : (
                  <button
                    type="button"
                    className="nav-button next-button"
                    onClick={handleNextStep}
                  >
                    Siguiente <BsChevronRight />
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  )
}

export default Request
